import { render, staticRenderFns } from "./LeadAssignmentHistoryModal.vue?vue&type=template&id=3a7e62c3"
import script from "./LeadAssignmentHistoryModal.vue?vue&type=script&lang=js"
export * from "./LeadAssignmentHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports